export const ADD_MEMBERSHIP_ITEM_MUTATION = `mutation addMembershipItem(
    $currency: Currency,
  ) {
    addMembershipItem(
      source: PRE_CHECKOUT
    ) {
      basket(currency: $currency) {
        itemsCount
        discountedItemsTotal {
          currency
          cents
        }
        itemsTotal {
          currency
          cents
        }
        items {
          product {
            code
            images {
              thumb
              medium
            }
            partner {
              id
              name
            }
            title
            prices {
              listPrice {
                currency
                cents
              }
            }
          }
        }
      }
      success
      errors {
        code
        message
        path
      }
    }
  }`;
